module.exports = __webpack_public_path__ + "static/Psychodynamic-e29a52170e12496b8df9d7f8d03f6e64.svg";